export const PARTNER_PASSWORD_RULES = {
  '[A-Z]': 'Pelo menos uma letra maiúscula',
  '[0-9]': 'Pelo menos um número',
  '.{8,}': 'Pelo menos 8 caracteres',
  '.{0,16}': 'Máximo 16 caracteres',
  '[^A-Za-z0-9]': 'Pelo menos um caractere especial',
};
